import request from "../helpers/request"
import { cacheCompanyId, resolveCompanyId } from "../helpers/companyLabels"

const PROFILE_CACHE_KEY = "companyProfileCache"
const CACHE_TTL_MS = 5 * 60 * 1000

let memoryCache = null
let memoryCacheToken = null
let inFlight = null

const readSessionCache = (token) => {
  try {
    const raw = sessionStorage.getItem(PROFILE_CACHE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed.token !== token || Date.now() - parsed.ts > CACHE_TTL_MS) return null
    return parsed.data
  } catch {
    return null
  }
}

const writeSessionCache = (token, data) => {
  try {
    sessionStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify({ token, ts: Date.now(), data }))
  } catch {
    /* ignore quota */
  }
}

export const invalidateCompanyProfile = () => {
  memoryCache = null
  memoryCacheToken = null
  inFlight = null
  try {
    sessionStorage.removeItem(PROFILE_CACHE_KEY)
  } catch {
    /* ignore */
  }
}

export const getStoredLoginUser = () => {
  try {
    const raw = localStorage.getItem("userData") || localStorage.getItem("userDataLast")
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.user ?? parsed
  } catch {
    return null
  }
}

const notifyProfileLoaded = (response) => {
  const companyId = resolveCompanyId(response)
  if (companyId != null) cacheCompanyId(companyId)
  window.dispatchEvent(new CustomEvent("profile:loaded", { detail: { companyId } }))
}

/** Tək sorğu + keş — bütün komponentlər bunu istifadə etməlidir */
export const fetchCompanyProfile = async ({ force = false } = {}) => {
  const token = localStorage.getItem("token")
  if (!token) {
    invalidateCompanyProfile()
    throw new Error("No token")
  }

  if (!force) {
    if (memoryCache && memoryCacheToken === token) return memoryCache
    const sessionCached = readSessionCache(token)
    if (sessionCached) {
      memoryCache = sessionCached
      memoryCacheToken = token
      return sessionCached
    }
    if (inFlight) return inFlight
  }

  inFlight = request
    .get("/api/company/profile/me", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      const data = res.data
      memoryCache = data
      memoryCacheToken = token
      writeSessionCache(token, data)
      notifyProfileLoaded(data)
      return data
    })
    .finally(() => {
      inFlight = null
    })

  return inFlight
}

export const login = async (data) => {
  const response = await request.post(`/api/auth/login/`, data)
  return response.data
}

/** @deprecated fetchCompanyProfile istifadə edin */
export const authUser = async (token) => {
  const activeToken = token || localStorage.getItem("token")
  if (!activeToken) throw new Error("No token")
  if (activeToken === localStorage.getItem("token")) {
    return fetchCompanyProfile()
  }
  const response = await request.get("/api/company/profile/me", {
    headers: { Authorization: `Bearer ${activeToken}` },
  })
  return response.data
}

export const updateUser = async (token, userData) => {
  const response = await request.put("/api/company/profile/update", userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  invalidateCompanyProfile()
  return response.data
}

export const setUserPassword = async (token, passwordData) => {
  const response = await request.post("/api/company/profile/update-password", passwordData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
